import { VariantSelects } from '@/scripts/theme/variant-selects'
import {
	getAttributeOrThrow,
	mediaLoader,
	qsaOptional,
	qsOptional,
	qsRequired,
} from '@/scripts/core/global'

export class VariantRadios extends VariantSelects {
	static override htmlSelector = 'variant-radios'
	static override selectors = {
		...VariantSelects.selectors,
	}
	kitComponentsMobile?: HTMLElement
	kitComponentsDesktop?: HTMLElement
	constructor() {
		super()
		this.kitComponentsMobile = qsOptional('[data-uc-kit-components="mobile"]')
		this.kitComponentsDesktop = qsOptional('[data-uc-kit-components="desktop"]')
	}

	override setInstanceSelectors() {
		this.instanceSelectors = VariantRadios.selectors
	}

	override setInputAvailability(
		listOfOptions: (HTMLInputElement | HTMLOptionElement)[],
		listOfAvailableOptions: (string | null)[]
	) {
		listOfOptions.forEach((input) => {
			if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
				input.classList.remove('disabled')
			} else {
				input.classList.add('disabled')
			}
		})
	}

	override updateOptions() {
		const fieldsetNodes = qsaOptional<HTMLFieldSetElement>('fieldset', this)
		if (!fieldsetNodes)
			throw new Error('cannot do updateOptions in variant-radios, no fieldset nodes found')
		const fieldsets = Array.from(fieldsetNodes)
		this.options = fieldsets.map((fieldset) => {
			if (fieldset.hasAttribute('data-uc-fieldset-color')) {
				return getAttributeOrThrow('data-uc-fieldset-color', fieldset)
			}
			const inputNodes = qsaOptional<HTMLInputElement>('input', fieldset)
			if (!inputNodes)
				throw new Error('cannot do updateOptions in variant-radios, no input nodes found')
			const inputs = Array.from(inputNodes)
			const checkedInput = inputs.find((radio) => radio.checked)
			if (!checkedInput)
				throw new Error('cannot do updateOptions in variant-radios, no checked input found')
			return checkedInput.value
		})
	}

	override onVariantChange(event: Event, isExternalUpdate = false) {
		super.onVariantChange(event, isExternalUpdate)
		if (
			(this.kitComponentsMobile || this.kitComponentsDesktop) &&
			!isExternalUpdate &&
			this.currentVariant
		) {
			fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=kit-components`)
				.then((response) => response.text())
				.then((html) => {
					const parser = new DOMParser()
					const doc = parser.parseFromString(html, 'text/html')
					const newKitComponentsMobile = qsOptional(
						'[data-uc-kit-components="mobile"]',
						doc
					)
					const newKitComponentsDesktop = qsOptional(
						'[data-uc-kit-components="desktop"]',
						doc
					)
					console.log({ newKitComponentsMobile, newKitComponentsDesktop })

					if (
						!newKitComponentsMobile &&
						!newKitComponentsDesktop &&
						!this.kitComponentsDesktop &&
						!this.kitComponentsMobile
					) {
						return
					}
					if (this.kitComponentsMobile && newKitComponentsMobile) {
						this.kitComponentsMobile.innerHTML = newKitComponentsMobile.innerHTML
					}
					if (this.kitComponentsDesktop && newKitComponentsDesktop) {
						this.kitComponentsDesktop.innerHTML = newKitComponentsDesktop.innerHTML
					}

					mediaLoader()
					if (
						this.kitComponentsMobile &&
						this.kitComponentsMobile.offsetParent !== null
					) {
						const elementPosition =
							this.kitComponentsMobile.getBoundingClientRect().top + window.scrollY

						window.scrollTo({
							top: elementPosition - 180, // Adjust the position by 150px
							behavior: 'smooth',
						})
					} else if (
						this.kitComponentsDesktop &&
						this.kitComponentsDesktop.offsetParent !== null
					) {
						const elementPosition =
							this.kitComponentsDesktop.getBoundingClientRect().top + window.scrollY

						window.scrollTo({
							top: elementPosition - 150, // Adjust the position by 150px
							behavior: 'smooth',
						})
					}
				})
				.catch((e) => {
					console.error(e)
					console.log('did not fetch kit components update')
				})
		}
	}

	override getSelectedOptions(): { name: string; value: string }[] {
		const fieldsetNodes = qsaOptional<HTMLFieldSetElement>('fieldset', this)
		if (!fieldsetNodes)
			throw new Error('cannot do updateOptions in variant-radios, no fieldset nodes found')
		const fieldsets = Array.from(fieldsetNodes).filter(
			(fieldset) => !fieldset.hasAttribute('data-uc-fieldset-color')
		)

		return fieldsets.map((fieldset) => {
			const inputNodes = qsaOptional<HTMLInputElement>('input', fieldset)
			if (!inputNodes)
				throw new Error('cannot do updateOptions in variant-radios, no input nodes found')
			const inputs = Array.from(inputNodes)
			const checkedInput = inputs.find((radio) => radio.checked)
			if (!checkedInput)
				throw new Error('cannot do updateOptions in variant-radios, no checked input found')

			return {
				name: getAttributeOrThrow('name', checkedInput),
				value: checkedInput.value,
			}
		})
	}

	override updateOptionsFromExternalSource(options: { name: string; value: string }[]) {
		options.forEach((option) => {
			const selectedInput = qsRequired<HTMLInputElement>(
				`input[name="${option.name}"][value="${option.value}"]`,
				this
			)
			selectedInput.checked = true
		})
		this.onVariantChange(new Event('externalVariantUpdate'), true)
	}
}
